import moment from 'moment'
export function secondsToDays(seconds) {
    try {
        var duration = moment.duration(seconds, 'seconds');
        var daysPart = Math.floor(duration.asDays());
        var hoursPart = duration.hours();
        var minutesPart = duration.minutes();
        var secondsPart = duration.seconds();
        var text = ""
        text += daysPart > 0 ? daysPart + " ngày " : "";
        text += hoursPart > 0 ? hoursPart + " giờ " : "";
        text += minutesPart > 0 ? minutesPart + " phút " : "";
        text += secondsPart > 0 ? secondsPart + " giây " : "";
        return text;
    } catch (error) {
        return "Lỗi: " + error;
    }
}